__turbopack_context__.v({
  "language-switcher__actions-list": "WS9uSW_language-switcher__actions-list",
  "language-switcher__chip": "WS9uSW_language-switcher__chip",
  "language-switcher__toggle-button": "WS9uSW_language-switcher__toggle-button",
  "language-switcher__toggle-button-icon": "WS9uSW_language-switcher__toggle-button-icon",
  "language-switcher__toggle-button-icon--mobile": "WS9uSW_language-switcher__toggle-button-icon--mobile",
  "language-switcher__toggle-button-text": "WS9uSW_language-switcher__toggle-button-text",
  "language-switcher__toggle-button__icon": "WS9uSW_language-switcher__toggle-button__icon",
});
